module.exports = __webpack_public_path__ + "img/AXS.b38dcae3.png";